
const getDefaultState = () => {
    return {
        data: {
            entradas: [],
            saidas: [],
            estoque: [],
            esseg: [],
            ppd: [],
            emax: [],
            referencias: [],
        },
    }
}

const state = getDefaultState();

const getters = {
    getRaioX(state) {
        return state;
    },
};

const mutations = {
    setData(state, val) {
        state.data = val;
    },
};

const actions = {
    setData: ({ commit }, val) => {
        commit('setData', val);
    },
    resetChart: ({ commit }) => {
        commit('setData', getDefaultState().data);
    },
};

export default { namespaced: true, state, mutations, getters, actions };
